import {
  Caption1,
  Caption1Stronger,
  ToggleButton,
  Tooltip,
  makeStyles,
  mergeClasses,
  tokens,
} from '@fluentui/react-components'
import { ChatAdd16Filled, ChatAdd16Regular } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'
import { useChatSession } from '../../hooks/useChatSession'

const useStyles = makeStyles({
  card: {
    borderRadius: tokens.borderRadius3XLarge,
    boxShadow: tokens.shadow4,
    flexShrink: 0,
  },
  button: {
    width: '100%',
    height: tokens.spacingVerticalXXL,
    justifyContent: 'center',
    borderRadius: tokens.borderRadius3XLarge,
    boxShadow: 'none',
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalXS}`,
  },
  buttonChecked: {
    backgroundColor: tokens.colorBrandBackground2,
  },
  iconChecked: {
    color: tokens.colorBrandForeground2,
  },
  labelChecked: {
    color: tokens.colorBrandForeground2,
    fontWeight: tokens.fontWeightSemibold,
  },
  tooltipContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    maxWidth: '260px',
  },
})

const ReviewModeButton = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { isCommentMode, setIsCommentMode, setReviewMode } = useChatSession()
  const commentModeAriaLabel = isCommentMode
    ? t('reviewMode.commentModeOn')
    : t('reviewMode.commentModeOff')
  const tooltipTitle = isCommentMode
    ? t('reviewMode.tooltipTitleOn')
    : t('reviewMode.tooltipTitleOff')
  const tooltipBody = isCommentMode ? t('reviewMode.tooltipBodyOn') : t('reviewMode.tooltipBodyOff')

  return (
    <div className={classes.card}>
      <Tooltip
        content={
          <div className={classes.tooltipContent}>
            <Caption1Stronger>{tooltipTitle}</Caption1Stronger>
            <Caption1 as="p">{tooltipBody}</Caption1>
          </div>
        }
        relationship="description"
        appearance="inverted">
        <ToggleButton
          onClick={() => {
            setIsCommentMode((prev) => !prev)
            setReviewMode(null) // will be sensed on send, based on context
          }}
          icon={
            isCommentMode ? (
              <ChatAdd16Filled aria-hidden={true} className={classes.iconChecked} />
            ) : (
              <ChatAdd16Regular aria-hidden={true} />
            )
          }
          shape="rounded"
          appearance="subtle"
          className={mergeClasses(classes.button, isCommentMode && classes.buttonChecked)}
          checked={isCommentMode}
          aria-label={commentModeAriaLabel}>
          <Caption1 className={isCommentMode ? classes.labelChecked : undefined}>
            {t('reviewMode.commentMode')}
          </Caption1>
        </ToggleButton>
      </Tooltip>
    </div>
  )
}

export { ReviewModeButton }
